__webpack_require__.p = "https://netvisorium.pl/";